import * as React from "react";
const SvgInfo = () => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.625 9a7.375 7.375 0 1 0 14.75 0 7.375 7.375 0 0 0-14.75 0M9 .5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M9.635 12.69V8.306a.714.714 0 0 0-1.427 0v4.384a.714.714 0 0 0 1.427 0M8.921 6.394a.899.899 0 1 0 0-1.797.899.899 0 0 0 0 1.797"
  }
));
export default SvgInfo;
